import type { SVGProps } from 'react';

const SvgBin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Delete">
      <g id="Group 4345">
        <path
          id="Rectangle 640"
          d="M4.32031 6.74481L4.93293 16.5467C4.99222 17.4954 5.77891 18.2344 6.72943 18.2344H13.4008C14.3513 18.2344 15.138 17.4954 15.1973 16.5467L15.8099 6.74481"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <g id="Group 908">
          <g id="Group 55039">
            <path
              id="Shape"
              d="M11.98 9.61719L10.065 11.5321L8.15011 9.61719"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Shape_2"
              d="M11.98 13.447L10.065 11.5321L8.15011 13.447"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <path
          id="Vector 234234409"
          d="M2.40527 4.13353H18.0729"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <g id="Group 55040">
          <path
            id="Vector 234234410"
            d="M1.92676 4.13353H4.62038C5.56952 4.13353 6.39686 3.48756 6.62705 2.56676V2.56676C6.85725 1.64597 7.68459 1 8.63373 1H10.2393H11.4967C12.4459 1 13.2732 1.64597 13.5034 2.56676V2.56676C13.7336 3.48756 14.561 4.13353 15.5101 4.13353H18.0731"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgBin;
